import { ColumnFiltersModel } from './index';
import { tableColumnFilters } from './tableColumnFilters';
import type { TableColumnFilters } from './tableColumnFilters';
import { computed, signal } from '@preact/signals-react';
import type { ReadonlySignal } from '@preact/signals-react';
import { filterableTemplateColumns } from 'src/features/table/columnFilters/columnFilterFormula';

/** Template columns as `filterableTemplateColumns` reads them. */
export type ColumnFilterTemplateColumns = Parameters<typeof filterableTemplateColumns>[0];

/** Session column filters for a widget model whose column template resolves outside it. */
export interface TemplateColumnFilters {
    readonly state: ColumnFiltersModel;
    readonly views: TableColumnFilters;
    /** Syncs the resolved template's columns, which decide eligibility, labels, and the formula. */
    setColumns(columns: ColumnFilterTemplateColumns): void;
}

/**
 * Session column filters (ADR 0014, Column Filter Contract) for legacy widget models whose column
 * template is resolved in React rather than on the model. The host syncs the resolved columns in;
 * ADR 0008 models that own their template compose `ColumnFiltersModel` and `tableColumnFilters`
 * directly instead. The caller owns `state` and disposes it with the model.
 */
export function templateColumnFilters(enabled: ReadonlySignal<boolean>): TemplateColumnFilters {
    const state = new ColumnFiltersModel();
    const columns = signal<ColumnFilterTemplateColumns>([]);
    const views = tableColumnFilters(state, {
        filterableColumns: computed(() => filterableTemplateColumns(columns.value)),
        enabled,
    });
    return {
        state,
        views,
        setColumns(next) {
            columns.value = next;
        },
    };
}
